import React from 'react';
import { useField, UseFieldConfig } from 'react-final-form';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Message from './Message';
import CustomLink from '../../../components/CustomLink';


const Container = styled.div`
  margin-top: 15px;
  max-width: 500px;
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.small}) {
    margin: 15px 0;
  }
`;

const StyledCheckbox = styled.input<{ isError: boolean | undefined }>`
  margin: 10px 5px 10px 0;
`;

const StyledCustomLink = styled(CustomLink)`
  padding: 0;
  margin-bottom: 10px;
`;

interface CheckboxProps {
  name: string,
  config?: UseFieldConfig<string>,
}

const PrivacyPolicyCheckbox = ({
  name,
  config,
  ...otherProps
}: CheckboxProps) => {
  const { input, meta } = useField(name, config);
  const { t } = useTranslation();

  return (
    <Container>
      <label htmlFor="policyPrivacy">
        <StyledCheckbox
          id="policyPrivacy"
          type="checkbox"
          isError={(meta.error && meta.touched && true)}
          {...input}
          {...otherProps}
        />
        {t('privacyPolicy.content')}
        <StyledCustomLink href="/information-clause" target="_blank">
          {t('privacyPolicy.link')}
        </StyledCustomLink>
      </label>
      <Message
        isVisible={(meta.error && meta.touched && true)}
        type="error"
      >
        {meta.error === 'theFieldIsRequired' ? t('privacyPolicyRequired') : t(meta.error)}
      </Message>
    </Container>
  );
};

export default PrivacyPolicyCheckbox;
